module.exports = __webpack_public_path__ + "img/1.7114252f.jpg";